import { CommonEditContext, CreateCommonSearchContext } from "./common-data.model";

export const DefaultITToolUsage = {
  search: CreateCommonSearchContext(),
  edit: {
    editForm: {
      model: {} as ITToolUsageEditCriteria,
      dirty: false,
      status: null as any,
      errors: null as any
    },
  } as CommonEditContext<ITToolUsageEditCriteria>,
}

export interface ITToolUsageEditCriteria {
  kpiId: string;
  compliance: boolean;
  occurrence: number;
  targetOccurrence: number;
}
